import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { getDefaultStore } from 'jotai'
import { notification } from 'antd'
import { authApi } from '@/api/auth.api'
import { sessionAtom } from '@/store/auth.atom'

export function useLogout() {
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () => {
            return authApi.logout()
        },
        onSuccess: (data) => {
            const message = (data as any)?.responseMessage || 'Đăng xuất thành công'
            notification.success({ message })
            getDefaultStore().set(sessionAtom, null)
            queryClient.clear()
            navigate({ to: '/login' })
        },
        onError: (error) => {
            const message = error instanceof Error ? error.message : 'Đã xảy ra lỗi khi đăng xuất.'
            notification.error({ message })
        },
        meta: { silent: true },
    })
}